import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { Col, InputGroup, Row } from "react-bootstrap";
import Logo from "../../../assets/images/logo.png";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Search from "../../../assets/images/search-line.svg";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "../login.css";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetNonAdfs,
  selectNonAdfs,
} from "../../../features/company/getNonAdfsSlice";
import { useHistory } from "react-router-dom";
import RegisteredUser from "./RegisteredUser";
function Login1() {
  const history = useHistory();
  const nonAdfs = useAppSelector(selectNonAdfs);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // alert("calling")
    async function fetchNonAdfs() {
      let sample = await dispatch(GetNonAdfs("all"));
    }
    fetchNonAdfs();
  }, []);

  //saerch
  const [search, setSearch] = useState("");
  const [filteredCompany, setFilteredCompany] = useState([]);
  useEffect(() => {
    if (nonAdfs) {
      var filtredRecord: any = nonAdfs?.filter((comapny: any) =>
        comapny.company.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredCompany(filtredRecord);
    }
  }, [search, nonAdfs]);

  const handleAdfsCheck = async (item: any) => {
    localStorage.removeItem("domainName");
    localStorage.removeItem("selectedId");
      console.log('item', item);
    if (item.adfs === true) {
      window.location.href = `${process.env.REACT_APP_MFA_LOGIN_URL}`;
      // window.location.href = `${process.env.REACT_APP_URL}/authentication/app/login`;
    } else {
      await localStorage.setItem(
        "domainName",
        JSON.stringify(item.emailidDomain)
      );
      await localStorage.setItem("selectedId", JSON.stringify(item.id));
      window.location.href = "/RegisteredUser";
    }
  };
  //console.log(isAdffs,"isAdffsisAdffs")
  return (
    <>
      <Container fluid style={{ height: "auto" }}>
        <Row>
          <Col sm={3}></Col>
          <Col
            className="bg-white tb-mar-mob0-desk48 mx-auto loginshadow"
            sm={6}
          >
            <div className="my-5 lr-mar-mob4-desk24">
              <Image
                className="mx-auto d-block"
                style={styles.limg}
                src={Logo}
              />
              <div className="mt-2 mb-3" style={styles.head}>
                Ethics and Governance portal
              </div>
              <Form autoComplete="new-password">
                <Row>
                  <Col lg={12}>
                    <InputGroup
                      className="border bg-white"
                      style={{ border: "solid 1px #e4e4e4" }}
                    >
                      <Image
                        style={styles.image1}
                        className="d-inline border-0 my-auto mx-2"
                        src={Search}
                        fluid
                      />
                      <Form.Control
                        className="border-0 shadow-none ps-0"
                        type="text"
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search by Company name"
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <ul className="list-group">
                  <Row className="mb-2">
                    {/* <Col sm={12} ><b style={styles.tableHeading}>Company Name</b></Col> */}
                    {/* <Col sm={6}><b style={styles.tableHeading}>Email Domain</b></Col> */}
                  </Row>
                  {filteredCompany?.map((item: any) => {
                    return (
                      <li
                        key={item.id}
                        className="list-group-item"
                        onClick={() => handleAdfsCheck(item)}
                      >
                        <Row>
                          <Col sm={12}>{item.company}</Col>
                          {/* <Col sm={6}>{item.emailidDomain}</Col> */}
                        </Row>
                      </li>
                    );
                  })}
                </ul>
                {/* <a href={`${process.env.REACT_APP_URL}/authentication/app/login`}>
                  <Button style={styles.btn1} variant="danger" type="button">
                    LOGIN WITH SSO
                  </Button>
                </a>
                <br/><br/>        
                
                <a href="/RegisteredUser">
                <Button style={styles.btn1}  variant="danger"  type="button" >
                 LOGIN FOR OTHER USERS
                </Button>
                </a> */}
              </Form>
            </div>
          </Col>
          <Col sm={3}></Col>
        </Row>
      </Container>
    </>
  );
}

const styles: any = {
  head: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: "500",
    textAlign: "center",
  },
  tableHeading: {
    fontSize: "16px",
  },
  limg: {
    width: "159px",
    height: "22px",
  },
  img1: {
    width: "24px",
    height: "24px",
  },
  checkb: {
    boxSizing: "border-box",
    boxShadow: "inset 0px 0px 0px 2px red",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    borderRadius: "0px",
    border: "solid 1px #e4e4e4",
  },
  text2: {
    textAlign: "right",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "red",
    textDecoration: "none",
  },
  text3: {
    fontFamily: "Saira",
    fontSize: "14px",
    textAlign: "center",
  },
  remember: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "normal",
    color: "black",
  },
  btn1: {
    width: "100%",
    height: "48px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "white",
    borderRadius: "0px",
    padding: "15px",
  },
  capcha: {
    fontSize: "14px",
    fontFamily: "Saira",
    color: "#cdcdcd",
    backgroundColor: "white",
    borderRadius: "0px",
    border: "solid 1px #e4e4e4",
  },
};

export default Login1;
